import Image from "next/image";

function Hero() {
  return (
    <div className="bg-terryWhite w-screen relative -mb-2 md:mt-24 mt-10">
      <Image
        src="/About us Hero.svg"
        alt="team"
        width={1920}
        height={1080}
        className="w-full h-[63vw] md:h-auto object-cover md:object-fill md:object-center object-left"
        unoptimized
      />
    </div>
  );
}

export default Hero;
